import { render, staticRenderFns } from "./PackageOptions.vue?vue&type=template&id=4008607c&scoped=true&"
import script from "./PackageOptions.vue?vue&type=script&lang=js&"
export * from "./PackageOptions.vue?vue&type=script&lang=js&"
import style0 from "./PackageOptions.vue?vue&type=style&index=0&id=4008607c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4008607c",
  null
  
)

export default component.exports